import { render, staticRenderFns } from "./CopyStakeWebAiStreamerProfileForm.vue?vue&type=template&id=561fb152&lang=pug"
import script from "./CopyStakeWebAiStreamerProfileForm.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWebAiStreamerProfileForm.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWebAiStreamerProfileForm.vue?vue&type=style&index=0&id=561fb152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VListItem,VRow,VSelect,VTextField,VTextarea})
